// The page sizes an element browser and the Data Management lists offer, in menu order (spec
// 2026-10-16). A pick goes to the API as `limit`; no pick sends none, and the server keeps its own
// size for the context.
export const PAGE_SIZES = [15, 25, 50, 100] as const;

// A first-page url with the picked page size on its query string: `?` after a bare url, `&` after
// one that already has a query. No size (null or undefined) returns the url as it came, so a
// request nobody chose a size for stays exactly what it is today.
//
// Only a first page takes it. A page link from the API (links.next, links.previous, links.current)
// already carries the limit of the request that produced it (NavigationProviderTrait in the PHP
// repo), so paging keeps the size on its own and a page link is fetched as given (spec 2026-10-16).
export const withPageSize = (url: string, limit?: number | null): string => {
    if (limit == null) return url;
    const separator = url.includes('?') ? '&' : '?';
    return `${url}${separator}limit=${limit}`;
};
